import clsx from 'clsx';
import { Clock } from 'lucide-react';

export const PikkoJackpotUrgencyCard = ({ isLastChance, displayDays, expiresAt, counterDone }) => {
  const parsedExpiry = expiresAt ? new Date(expiresAt).getTime() : NaN;
  const expiredDays = Number.isFinite(parsedExpiry)
    ? Math.max(1, Math.ceil((Date.now() - parsedExpiry) / (1000 * 60 * 60 * 24)))
    : 1;

  return (
  <div
    className={clsx(
      'flex flex-col gap-4 [@media(max-height:700px)]:gap-2.5 w-full rounded-2xl p-4 [@media(max-height:700px)]:p-3 border transition-all duration-500 delay-[350ms]',
      { 'bg-gray-50 border-gray-200': isLastChance, 'bg-amber-50/60 border-amber-100': !isLastChance },
      { 'opacity-100 translate-y-0': counterDone, 'opacity-0 translate-y-3': !counterDone },
    )}
  >
    {/* Days remaining */}
    <div className='flex items-center justify-center'>
      <span className='text-[15px] [@media(max-height:800px)]:text-[13px] [@media(max-height:700px)]:text-[12px] text-semibold text-gray-800 flex items-center gap-2'>
        <Clock size={16} className={clsx('transition-colors duration-700', { 'stroke-gray-400': isLastChance, 'stroke-gray-800': !isLastChance })} />
        {isLastChance
          ? <span className='text-gray-400 font-semibold'>Expiré depuis {expiredDays} jour{expiredDays > 1 ? 's' : ''}</span>
          : <>Disponible encore <span className='text-amber-600 font-semibold'>{displayDays} jour{displayDays > 1 ? 's' : ''}</span></>
        }
      </span>
    </div>
    <div className={clsx('w-full h-1.5 rounded-full overflow-hidden transition-colors duration-700', { 'bg-gray-200': isLastChance, 'bg-amber-100': !isLastChance })}>
      <div
        className='h-full rounded-full transition-all duration-1000 ease-out'
        style={{
          width: isLastChance ? '100%' : `${Math.max(5, Math.min(100, (displayDays / 7) * 100))}%`,
          background: isLastChance
            ? 'linear-gradient(90deg, #9CA3AF, #D1D5DB)'
            : displayDays <= 2
              ? 'linear-gradient(90deg, #ef4444, #f87171)'
              : displayDays <= 4
                ? 'linear-gradient(90deg, #f59e0b, #fbbf24)'
                : 'linear-gradient(90deg, #f3d349, #fbbf24)',
        }}
      />
    </div>

    {/* Divider */}
    <div className={clsx('w-full h-px transition-colors duration-700', { 'bg-gray-200': isLastChance, 'bg-amber-100': !isLastChance })} />

    {/* Social proof */}
    <div className='flex items-center gap-2.5'>
      <div className="flex items-center shrink-0">
        {['😊', '🙂', '😄', '🤩'].map((emoji, index) => (
          <div
            key={emoji}
            className={clsx(
              'w-6 h-6 rounded-full border-2 flex items-center justify-center text-[11px] transition-all duration-700',
              { 'bg-gray-100 border-gray-50 grayscale': isLastChance, 'bg-amber-100 border-amber-50': !isLastChance, '-ml-1.5': index > 0 },
            )}
          >
            {emoji}
          </div>
        ))}
      </div>
      <span className={clsx('text-[12px] [@media(max-height:800px)]:text-[11px] font-medium leading-tight transition-colors duration-700', { 'text-gray-400': isLastChance, 'text-amber-800': !isLastChance })}>
        2 847 personnes ont récupéré leurs cadeaux
      </span>
    </div>
  </div>
  );
};
